import * as React from "react"
import { cn } from "../../lib/utils"

export interface Tab {
  id: string
  label: string
  icon?: React.ComponentType<{ className?: string }>
}

interface TabsProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
  variant?: 'button' | 'underline'
}

export function Tabs({ tabs, activeTab, onTabChange, className, variant = 'button' }: TabsProps) {
  if (variant === 'underline') {
    return (
      <div className={cn("flex max-w-full gap-4 overflow-x-auto border-b", className)}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "pb-2 px-1 text-sm font-medium transition-colors relative flex items-center gap-2",
              activeTab === tab.id ? "text-primary" : "text-muted-foreground hover:text-foreground"
            )}
          >
            {tab.icon && <tab.icon className="h-4 w-4" />}
            {tab.label}
            {activeTab === tab.id && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />}
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className={cn("flex max-w-full flex-wrap items-center justify-start gap-1 rounded-md bg-muted p-1 text-muted-foreground", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
            activeTab === tab.id
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {tab.icon && <tab.icon className="h-4 w-4 mr-2" />}
          {tab.label}
        </button>
      ))}
    </div>
  )
}
